<template>
    <div class="desktop-main">
        <div class="desktop-body">
            <div class="desktop-title">运 营 管 理 平 台</div>
        </div>
    </div>
</template>

<script>
import NProgress from 'nprogress'

export default {
    components: { 
    },
    data() {
        return {
            
        }
    },
    filters: {
    },
    methods: {
        init(){
            NProgress.start();
            NProgress.done();
        }
    },
    beforeRouteLeave(to, from, next){
        next();
    },
    mounted() {
        this.init()
    }
}

</script>

<style lang="scss" scoped>
.desktop-main {
    width: 100%;
    height: calc(100vh - 80px);

    .desktop-body {
        width: 100%;
        height: 100%;
        position: relative;
        background-image: url(../../assets/xizilangqiao_bg.jpg);
        background-position: center center; /* 水平垂直居中 */
        background-repeat: no-repeat; /* 不重复 */
        // background-attachment: fixed; /* 背景固定，内容滚动 */
        background-size: cover; /* 背景图片覆盖整个容器 */
        opacity: 0.6; /* 设置透明度 */

        .desktop-title {
            position: relative;
            text-align: center;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: white;
            font-size: 50px;
            font-weight: 600;
            font-family: cursive, fangsong;
        }
    }
}
/* 伪元素样式 */
// .desktop-body::before {
//     content: '';
//     width: 100%;
//     height: 100%;
//     position: absolute;
//     top: 0;
//     left: 0;
//     right: 0;
//     bottom: 0;
//     background-image: url(../../assets/bg4_tunnel.jpg);
//     background-position: center center; /* 水平垂直居中 */
//     background-repeat: no-repeat; /* 不重复 */
//     background-attachment: fixed; /* 背景固定，内容滚动 */
//     background-size: cover; /* 背景图片覆盖整个容器 */
//     opacity: 0.6; /* 设置透明度 */
//     z-index: 99; /* 确保伪元素在背景下 */
// }
</style>


// WEBPACK FOOTER //
// desktop.vue?06db8df2